import React, { useRef, useState, useEffect } from 'react'
import logo from '../Images/logo-main-black.png'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert'

//firebase
import {db} from '../firebase';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { collection, query, getDocs, where } from "firebase/firestore";

//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

function Login() {

    let navigate = useNavigate();
    const location = useLocation();
    const emailRef = useRef();
    const passwordRef = useRef();
    const [showAlert, setShowAlert] = useState(false);
    const [showProgress, setShowProgress] = useState(false);
    const [showSignInbtn, setShowSignInbtn] = useState(true);
    const [therrorMessage, setErrorMessage] = useState("");
    const videoRef = useRef(null); // Reference for the video element
    const [showPassword, setShowPassword] = useState(false);
    const [isMobile, setIsMobile] = useState(() => (
      typeof window !== 'undefined' ? window.innerWidth <= 768 : false
    ));
    const redirectPath = new URLSearchParams(location.search).get('redirect') || '';
    const safeRedirectPath = redirectPath.startsWith('/') ? redirectPath : '';
    const isInterviewRedirect = safeRedirectPath.startsWith('/interviews');

    function SignInUser(event){
        if (event) {
            event.preventDefault();
        }

        const email = emailRef.current.value.trim();
        const password = passwordRef.current.value;
        const auth = getAuth();

        if (!email || !password) {
            setShowAlert(true)
            setErrorMessage("Enter both your email address and password to continue.")
            setShowProgress(false)
            setShowSignInbtn(true)
            return;
        }

        setShowProgress(true);
        setShowAlert(false);
        setShowSignInbtn(false)

        //sign in a user
        signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
            // Signed in 
            //now lets check who has loggedin 
            //store their user id in the const name below
            let userID = userCredential.user.uid

            const q = query(collection(db, "users"), where("userId", "==", userID));
            getDocs(q).then((QuerySnapshot)=>{
                QuerySnapshot.forEach((doc)=>{

                    let userType = doc.data().userType;

                    if (userType === "Instructor" ){
                        navigate("/in/dashboard")
                    }else if(userType === "student"){
                        navigate(safeRedirectPath || "/dashboard")
                    }             
                    
                })
            })

        })
        .catch((error) => {
            //const errorCode = error.code;

            const errorCode = error.code;
            let errorMessage;

            switch (errorCode) {
                case "auth/user-not-found":
                  errorMessage = "No user found with this email.";
                  break;
                case "auth/wrong-password":
                  errorMessage = "Incorrect password. Please try again.";
                  break;
                case "auth/invalid-email":
                  errorMessage = "Invalid email address. Please check and try again.";
                  break;
                default:
                  errorMessage = "An error occurred. Please try again.";
            }

            setShowAlert(true)
            setErrorMessage(errorMessage)    
            setShowProgress(false)
            setShowSignInbtn(true)
        });
    }

    useEffect(() => {
        const updateIsMobile = () => {
          setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', updateIsMobile);
        updateIsMobile();

        return () => window.removeEventListener('resize', updateIsMobile);
    }, []);

    useEffect(() => {
        if (isMobile || !videoRef.current) {
          return;
        }

        // Attempt to programmatically play the video
        if (videoRef.current) {
          videoRef.current
            .play()
            .catch(error => console.error("Autoplay blocked:", error));
        }
    }, [isMobile]); // Runs when the viewport changes


  return (
    <div className='d-flex loginContainer'>
        {!isMobile && (
          <div className='loginLeft'>
            <video
              ref={videoRef}
              src="https://res.cloudinary.com/ubunifu/video/upload/v1607186910/pexels-rodnae-productions-5923291_jd1rwl.mp4"
              muted
              autoPlay
              loop
              playsInline
            ></video>
          </div>
        )}

        <div className='loginRight'>
            <Link to="/"><img src={logo} alt="" className='loginLogo' /></Link>   
            <h5 className='welTxt'>Welcome back!</h5>   
            <h6>{isInterviewRedirect ? 'Sign in with the email address and password you used during registration to open your interview.' : 'Enter your email address and password to access your account.'}</h6> 

            <Form onSubmit={SignInUser} className='authFormShell'>
            <Form.Label className="inputLabel">Email</Form.Label>
            <InputGroup className="mb-3 loginInputGroup">               
            <InputGroup.Text id="login-email-addon" className="loginInputAddon">
                <FontAwesomeIcon icon={faEnvelope} className="theLoginIcon"/>
            </InputGroup.Text>
                    <Form.Control
                    placeholder="Enter your email"
                    aria-label="Enter your email"
                    type="email"
                    aria-describedby="login-email-addon"
                    className='loginForm'
                    ref={emailRef}
                    autoComplete="email"
                    spellCheck={false}
                    autoFocus
                    />
            </InputGroup> 

            <Form.Label className="inputLabel">Password</Form.Label>
            <InputGroup className="mb-3 loginInputGroup">               
            <InputGroup.Text id="login-password-addon" className="loginInputAddon">
                <FontAwesomeIcon icon={faLock} className="theLoginIcon"/>
            </InputGroup.Text>
                    <Form.Control
                    placeholder="Enter your password"
                    aria-label="Enter your password"
                    type={showPassword ? "text" : "password"}
                    aria-describedby="login-password-addon"
                    className='loginForm'
                    ref={passwordRef}
                    autoComplete="current-password"
                    />
            <InputGroup.Text className="passwordToggle">
                <button
                    type="button"
                    className="passwordToggleBtn"
                    aria-label={showPassword ? "Hide password" : "Show password"}
                    aria-pressed={showPassword}
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={() => setShowPassword((prev) => !prev)}
                >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} className="theLoginIcon"/>
                </button>
            </InputGroup.Text>
            </InputGroup> 

            {showAlert && 
                <Alert variant={'danger'}  >
                    {therrorMessage}
                </Alert>
            }
            
            <div className='authMetaRow'>
                <p className="text-muted mb-0"><Link to="/forgot-password" className='fgPassLink text-muted'>Forgot Password?</Link></p>
                {isInterviewRedirect && <span className='authMetaHint'>Interview access</span>}
            </div>
           
            {showSignInbtn && 
                <button  type="submit" className='signInbtnn'>
                    Sign In
                </button>  
            }

            {showProgress && 
                <Button variant="primary" disabled  className='signInbtnnLoading' >
                    <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    />
                    <span> Logging in...</span>
                </Button>
            }
            </Form>
        </div>     
    </div>
  )
}

export default Login
